// extracted by mini-css-extract-plugin
export default {"Texture":"ScreenshotComponent_Texture__ESS7X"};